<template>
  <div>
    <Window v-if="isReady"/>
    <About/>
  </div>
</template>

<script>
  import 'styles/index.scss';
  import Window from 'components/Window';
  import About from 'components/About';
  import { getQueryStringParams } from 'lib/utils';

  export default {
    name: 'App',
    components: {
      Window,
      About,
    },
    data() {
      return {
        isReady: false
      };
    },
    mounted() {
      window.onresize = function () {
        document.body.height = window.innerHeight;
      };
      window.onresize();

      window.parent && window.parent.postMessage('amy:ready', '*');
      setTimeout(() => {
        this.isReady = true;
      }, 300);
    }
  };
</script>
